import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: number = 1;

const countSlice = createSlice({
  initialState,
  name: "count",
  reducers: {
    setMyCount: (state: number, action: PayloadAction<number>) => {
      return action.payload;
    },
  },
});

export const { setMyCount } = countSlice.actions;

export default countSlice.reducer;
